import { getGlobals } from '../globals'
import { getUserId } from '../storage'
import { blacklistWebhooks } from './integrations'
import { prefixAjsLocalStorage } from '../analytics-storage'

const isProduction = process.env.NODE_ENV === 'production'

// const isProduction = true;

export function track(name, trackingObj, options = {}) {

  const adjustedTrackingObj = Object.assign({}, trackingObj, getGlobals())

  if (!isProduction) {
    console.log('track', !!window.analytics, name, adjustedTrackingObj,
      options)
  }

  if (window.analytics && isProduction) {
    try {
      window.analytics.track(name, adjustedTrackingObj, options)
    } catch (err) {
      console.warn('tracking => track', err)
    }
  }
}

export function page(page) {
  const trackingObj = {
    ...getGlobals(),
    pageType: page.tags[0],
  }

  if (!isProduction) {
    console.log('page', !!window.analytics, page.name, trackingObj)
  }

  if (window.analytics && isProduction) {
    try {
      window.analytics.page(null, page.name, trackingObj)
    } catch (err) {
      console.warn('tracking => page', err)
    }
  }
}

export function identify(userInformation) {
  getUserId((userId) => {
    const globals = getGlobals()

    if (!userInformation.id) {
      userInformation.id = userId
    }

    const adjustedUserInformation = Object.assign({}, userInformation)

    if (!isProduction) {
      console.log('identify', !!window.analytics, adjustedUserInformation)
    }

    if (window.analytics && isProduction) {
      try {
        window.analytics.identify(userId, adjustedUserInformation, {
          ...blacklistWebhooks,
          Intercom: { hideDefaultLauncher: true },
        })
      } catch (err) {
        console.warn('tracking => identify', err)
      }
    }

    prefixAjsLocalStorage(globals.perspectiveCompanyId)
  })
}
